/**
 * Detect phone / iPad / tablet so apply flow can skip Assessment on handhelds.
 * Re-check on each call (orientation / resize may change).
 */
export function isHandheldDevice() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const maxTouchPoints = Number(navigator.maxTouchPoints) || 0;

  // iPadOS 13+ often reports as Macintosh with touch points
  const isIpadOs =
    /iPad/i.test(ua) ||
    (platform === 'MacIntel' && maxTouchPoints > 1);

  const isPhoneOrTabletUa =
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet|Kindle|Silk/i.test(
      ua
    );

  if (isIpadOs || isPhoneOrTabletUa) {
    return true;
  }

  const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
  const tabletOrSmaller = window.matchMedia('(max-width: 1024px)').matches;
  return coarsePointer && tabletOrSmaller;
}
